import {basePageableGraphqlField, baseResponseGraphqlField} from "../../../store/base.graphql";
import {gql} from "apollo-angular";


export interface NotificationModel {
  id?: string;
  uniqueId?: string;
  message?: string;
  isRead?: string;
  callbackItemId?: string;
  notificationType?: 'SERVICE_APPROVAL_REQUEST' | 'SERVICE_CHANGE_REQUEST';
  createdAt?: string;
}


const notificationFields = `
id
uniqueId
message
isRead
callbackItemId
notificationType
createdAt
`

export const GET_NOTIFICATIONS = gql`
query GetNotifications($filtering: NotificationFilteringInputObject) {
  getNotifications(filtering: $filtering) {
    ${baseResponseGraphqlField}
    ${basePageableGraphqlField}
    stats {
      totalUnread
    }
    data {
      ${notificationFields}
    }
  }
}
`


export const UNREAD_NOTIFICATION = gql`
mutation UnreadNotificationMutation($input: UnreadNotificationInputObject!) {
  unreadNotificationMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${notificationFields}
    }
  }
}
`

